import React, { Component } from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInstagram, faFacebookSquare } from "@fortawesome/free-brands-svg-icons";


export default class Social extends Component {

    render() {
        const { company = [] } = this.props;

        return (
            <Container style={{ height: "20vh" }}>
                <Row className="h-100">
                    <Col xs={12} lg={4} className="d-none d-lg-flex align-items-center justify-content-start">
                        <Image src={company.image.logo} width={150} />
                    </Col>
                    <Col xs={12} lg={4} className="d-flex align-items-center justify-content-center">
                        <a href={company.site} rel="noopener noreferrer" className="text-muted text-uppercase" target="_Blank">Acessar {company.name}</a>
                    </Col>
                    <Col xs={12} lg={4} className="d-flex align-items-center justify-content-center justify-content-lg-end">
                        <a href={company.instagram} target="_Blank" rel="noopener noreferrer" className="text-muted" style={{ fontSize: "30px" }}><FontAwesomeIcon icon={faInstagram} /></a>
                        <a href={company.facebook} target="_Blank" rel="noopener noreferrer" className="text-muted ml-2" style={{ fontSize: "30px" }}><FontAwesomeIcon icon={faFacebookSquare} /></a>
                    </Col>
                </Row>
            </Container>
        );
    }
}